import { Fragment, useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import { useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';
import { FaSearch } from "react-icons/fa";
import { getData } from "../../api/ApiRest";
import { Grid, Paper } from "@mui/material";
import { formatNumber } from "../../widgets/FormatNumber";
import ButtonOptions from "../../components/common/ButtonOptions";
import { FaMinus, FaPlus } from "react-icons/fa6";

function EmisionPrefijos() {
    const adminTae = useSelector((state) => state.auth.AdminTae);
    const companyId = useSelector((state) => state.auth.CompanyId);

    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({});
    const [registros, setRegistros] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [prefijos, setPrefijos] = useState([]);
    const [year, setYear] = useState([]);

    useEffect(() => {
        const actual = new Date().getFullYear();
        const mesActual = new Date().getMonth() + 1;

        const nuevosValores = [];

        for (let i = 0; i < 1; i++) {
            nuevosValores.push(actual - 1);
            nuevosValores.push(actual);
            nuevosValores.push(actual + 1);
        }

        setYear(nuevosValores);

        setDataBuscar({ ...dataBuscar, Year: nuevosValores.filter(x => x === actual)[0], Mes: mes.filter(x => x.valor === mesActual)[0].valor });
    }, [])

    ///Array de meses
    const mes = [
        { nombre: "Enero", valor: 1 },
        { nombre: "Febrero", valor: 2 },
        { nombre: "Marzo", valor: 3 },
        { nombre: "Abril", valor: 4 },
        { nombre: "Mayo", valor: 5 },
        { nombre: "Junio", valor: 6 },
        { nombre: "Julio", valor: 7 },
        { nombre: "Agosto", valor: 8 },
        { nombre: "Septiembre", valor: 9 },
        { nombre: "Octubre", valor: 10 },
        { nombre: "Noviembre", valor: 11 },
        { nombre: "Diciembre", valor: 12 }
    ];

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    const toggleMostrarRecibos = (categoria) => {
        setExpandedRows((prev) => prev.includes(categoria) ? prev.filter(x => x !== categoria) : [...prev, categoria]);
    }

    ///Acción para buscar los registros de acuerdo a unos parametros previamente establecidos
    const buscarRegistros = async (event) => {
        event.preventDefault();
        setLoading(true);

        if (dataBuscar.Cliente === undefined && (companyId === 'null' || companyId === null)){
            alert('Debes seleccionar un cliente');
            setLoading(false);
            return;
        }

        await getData('api/Cliente/Dashboard/GetReporteClientesDocumentos', {
            mes: dataBuscar.Mes,
            CompanyId: dataBuscar.Cliente || '',
            year: dataBuscar.Year
        }).then(response => {
            setRegistros(response.categoriaAgrupados);
            setPrefijos(response.registrosDoc);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Documentos</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarRegistros}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Mes"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Mes}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar, Mes: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            {mes.map((item, index) => (
                                <option value={item.valor} key={item.valor}>{item.nombre}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Año"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Year}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar, Year: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            {year.map((item, index) => (
                                <option value={item} key={index}>{item}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                {adminTae === 'true' ?
                    <div className='col-md-5'>
                        <AsyncSelect cacheOptions defaultOptions
                            menuPosition='fixed'
                            noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                            placeholder="Cliente"
                            isClearable={true}
                            loadOptions={companieSearchSelect2}
                            onChange={value => {
                                if (value === null)
                                    setDataBuscar({ ...dataBuscar, Cliente: '' })
                                else
                                    setDataBuscar({ ...dataBuscar, Cliente: value.value })
                            }}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: 50
                                })
                            }}
                        />
                    </div>
                    : null}

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        {registros.length > 0 ?
            <Grid container spacing={1} padding={2}>
                <Paper elevation={3} style={{ padding: '20px', height: '100%', width: '100%' }}>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado"></th>
                                <th className="estilo-encabezado">Categoría</th>
                                <th className="estilo-encabezado">Cantidad</th>
                                <th className="estilo-encabezado">Total $</th>
                            </tr>
                        </thead>
                        <tbody>
                            {registros.map((item, index) => (
                                <Fragment key={index}>
                                    <tr>
                                        <td className="text-center">
                                            <>
                                                <ButtonOptions
                                                    withIconButton={true}
                                                    iconButton={
                                                        expandedRows.includes(item.categoria) ? <FaMinus /> : <FaPlus />
                                                    }
                                                    colorButton="warning"
                                                    labelTitle="Nuevo ciclo"
                                                    onClickButton={() => toggleMostrarRecibos(item.categoria)}
                                                    fontSize={9}
                                                />
                                            </>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.categoria}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            {formatNumber(item.cantidad)}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            $ {formatNumber(item.total)}
                                        </td>
                                    </tr>

                                    {expandedRows.includes(item.categoria) && prefijos.filter(x => x.categoria === item.categoria).map((prefijos) => {
                                        return (
                                            <tr key={prefijos.categoria}>
                                                <td></td>
                                                <td className="text-center" style={{ fontSize: '14px' }}>{prefijos.prefijo}</td>
                                                <td style={{ textAlign: 'right', fontSize: '14px' }}>{formatNumber(prefijos.cantidad_documentos)}</td>
                                                <td style={{ textAlign: 'right', fontSize: '14px' }}>$ {formatNumber(prefijos.total_documentos)}</td>
                                            </tr>
                                        )
                                    })}
                                </Fragment>
                            ))}
                        </tbody>
                    </table>
                </Paper>
            </Grid>
            : null}
    </div>
}

export default EmisionPrefijos;